import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'

import DateRange from '../../../commons/components/DateRange'
import 'element-theme-default';

import { i18n } from 'element-react'
import locale from 'element-react/src/locale/lang/ko'

i18n.use(locale);


/**
 * 과거 발전소 이슈 내역
 */
class HistoryDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            plantId: props.match.params.plantId,
            fromDate: '',
            toDate: '',
            histories: [],
            count: 0
        }
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.getHistoryDetail();
    }

    async getHistoryDetail() {
        let res = await axios.get(`/cst/api/plant-issue/history-detail/${this.state.plantId}`);
        //console.log(res.data);
        this.setState({
            histories: res.data.result,
            count: res.data.size
        })
    }


    handleDateChange(ranges) {
        this.setState({
            fromDate: ranges[0],
            toDate: ranges[1]
        })
    }


    issueClick(idx, issueId) {
        this.state.histories.some(v => {
            let re = v.issues.filter((item) => item.id === issueId);
            if(re.length > 0 ) {
                document.getElementById("reason_" + idx).innerText = re[0].faultCode;
                document.getElementById("solution_" + idx).innerText = re[0].solution;
                document.getElementById("ct_" + idx).innerText = re[0].createDt;
                document.getElementById("et_" + idx).innerText = re[0].issueEndingDt;
                return true;
            }
        })
        return;
    }


    render() {
        const { histories, count } = this.state

        return (
            <>
                <div className="page-tit gray">
                    <div className="container f-stack">
                        <h2 className="tit">발전소별 현장출동 내역</h2>
                        <div className="lookUp-btn">
                        </div>
                    </div>
                </div>
                <div className="container">
                    <h3  className="content-tit3">인버터별 과거 현장출동 내역</h3>
                    <div className="top-search">
                        <div className="txt"><strong>전체보기</strong> 총 {count}건</div>
                        <div className="search">
                            <form onSubmit={e => e.preventDefault()}>
                                <DateRange handleDateChange={this.handleDateChange} />
                                &nbsp;
                                <select title="검색선택">
                                    <option value="" >전체</option>
                                    <option value="">연락처</option>
                                    <option value="">발전소명</option>
                                </select>
                                <span className="search">
                                    <input type="text" placeholder="입력" />
                                    <button type="button" className="material-icons">search</button>
                                </span>
                            </form>
                        </div>
                    </div>


                    <div className="past-list">

                        {
                            histories.map((row, index) => (
                                <div className="group" key={row.inverterSerialNo}>
                                    <a href="#" className="active">
                                        <div className="top">
                                            <div className="tit">{row.inverterSerialNo}</div>
                                        </div>
                                        <div className="module">
                                            <span className="tit">해당 모듈</span>
                                            <div className="inline">
                                            {
                                                row.issues.map(issue => (
                                                    <label className="white-label" key={issue.faultCode} onClick={() => this.issueClick(index, issue.id)}>
                                                        {issue.faultCode}
                                                    </label>
                                                ))
                                            }
                                            </div>
                                        </div>
                                        <div className="memo">
                                            <div>
                                                <div className="h-stack">
                                                    <div className="tit w40">원인</div>
                                                    <div className="txt bold" id={"reason_" + index}>{row.issues[0].faultCode}</div>
                                                </div>
                                                <div className="h-stack">
                                                    <div className="tit w40">시간</div>
                                                    <div className="txt date" id={"ct_" + index}>{row.issues[0].createDt}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="h-stack">
                                                    <div className="tit w40">해결</div>
                                                    <div className="txt bold" id={"solution_" + index}>{row.issues[0].solution}</div>
                                                </div>
                                                <div className="h-stack">
                                                    <div className="tit w40">시간</div>
                                                    <div className="txt date" id={"et_" + index}>{row.issues[0].issueEndingDt}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </>
        )
    }
}

export default HistoryDetail
